/* Collage « Excel » dans les grilles de mois : un collage multi-valeurs
   (tabulations / retours ligne / points-virgules) remplit les mois suivants
   de la ligne à partir de la cellule visée. Nombres au format suisse admis
   (apostrophes de milliers, virgule décimale). Un collage d'une seule valeur
   garde le comportement normal du champ. */
export const parsePasteSeries = (e) => {
  const txt = (e.clipboardData && e.clipboardData.getData('text')) || '';
  const parts = txt.split(/[\t\n\r;]+/).map((x) => x.trim()).filter((x) => x !== '');
  if (parts.length < 2) return null;
  const nums = parts.map((v) => {
    const x = parseFloat(String(v).replace(/['\s’]/g, '').replace(',', '.'));
    return Number.isFinite(x) ? x : 0;
  });
  return nums;
};
